import { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut as fbSignOut } from 'firebase/auth';
import { auth } from '../firebase.js';

// [BB-fix P0#2] VITE_AUTH_BYPASS short-circuits the real auth flow with a
// synthetic operator. It is invaluable during local dev (no Google sign-in,
// no token refresh) but catastrophic in production — anyone who hits the URL
// becomes the "dev-operator" with full UI access. Refuse to boot the bypass
// path in any production build, regardless of how the env var got set.
const env = import.meta.env || {};
const isProd = env.PROD === true || env.MODE === 'production' || env.NODE_ENV === 'production';
const bypassRequested = env.VITE_AUTH_BYPASS === '1';

if (bypassRequested && isProd) {
  throw new Error(
    '[useAuth] VITE_AUTH_BYPASS is set in a production build. ' +
    'This would grant unauthenticated callers full operator access. ' +
    'Unset VITE_AUTH_BYPASS in your production env or use a non-prod build.',
  );
}

const DEV_FAKE_USER = bypassRequested && !isProd
  ? { uid: 'dev-operator', email: 'remi@digitaltrvst.com' }
  : null;

export function useAuth() {
  const [user, setUser] = useState(() => DEV_FAKE_USER || auth.currentUser);
  const [loading, setLoading] = useState(!DEV_FAKE_USER);

  useEffect(() => {
    if (DEV_FAKE_USER) return;
    return onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  return { user, loading, signOut: () => (DEV_FAKE_USER ? null : fbSignOut(auth)) };
}
